/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemConfiguration } from './TaskWorkflowItemConfiguration';
import {
    TaskWorkflowItemConfigurationFromJSON,
    TaskWorkflowItemConfigurationFromJSONTyped,
    TaskWorkflowItemConfigurationToJSON,
    TaskWorkflowItemConfigurationToJSONTyped,
} from './TaskWorkflowItemConfiguration';

/**
 * 
 * @export
 * @interface CreateTaskWorkflowItemConfiguration201Response
 */
export interface CreateTaskWorkflowItemConfiguration201Response {
    /**
     * 
     */
    data: TaskWorkflowItemConfiguration;
}

/**
 * Check if a given object implements the CreateTaskWorkflowItemConfiguration201Response interface.
 */
export function instanceOfCreateTaskWorkflowItemConfiguration201Response(value: object): value is CreateTaskWorkflowItemConfiguration201Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateTaskWorkflowItemConfiguration201ResponseFromJSON(json: any): CreateTaskWorkflowItemConfiguration201Response {
    return CreateTaskWorkflowItemConfiguration201ResponseFromJSONTyped(json, false);
}

export function CreateTaskWorkflowItemConfiguration201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskWorkflowItemConfiguration201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TaskWorkflowItemConfigurationFromJSON(json['data']),
    };
}

export function CreateTaskWorkflowItemConfiguration201ResponseToJSON(json: any): CreateTaskWorkflowItemConfiguration201Response {
    return CreateTaskWorkflowItemConfiguration201ResponseToJSONTyped(json, false);
}

export function CreateTaskWorkflowItemConfiguration201ResponseToJSONTyped(value?: CreateTaskWorkflowItemConfiguration201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TaskWorkflowItemConfigurationToJSON(value['data']),
    };
}

